// Services
import { getFromApi } from 'actions'

export async function _getProfileImage(dispatch) {
   const url = `${process.env.REACT_APP_AUTHORIZATION_API}/user/profile/picture`
   const { base64Url: photo } = await getFromApi(url)
   dispatch({
      type: 'SET_USER_AVATAR_PHOTO',
      payload: { photo }
   })
}
